<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clip-path="url(#clip0_1402_75344)">
      <path
        d="M20 3.60396L24.1322 13.5389C24.4202 14.2314 25.0714 14.7045 25.819 14.7645L36.5446 15.6243L28.3728 22.6243C27.8032 23.1122 27.5545 23.8778 27.7285 24.6073L30.2251 35.0737L21.0425 29.465C20.4025 29.074 19.5975 29.074 18.9575 29.465L9.77486 35.0737L12.2715 24.6073C12.4455 23.8778 12.1968 23.1122 11.6272 22.6243L3.45538 15.6243L14.181 14.7645C14.9286 14.7045 15.5798 14.2314 15.8678 13.5389L20 3.60396Z"
        :stroke="stroke"
        stroke-width="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1402_75344">
        <rect width="40" height="40" :fill="fill" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#FEC84B",
  },
  stroke: {
    type: String,
    default: "#FEC84B",
  },
  fill: {
    type: String,
    default: "#ffffff",
  },
});
</script>
